import Modal from './Modal';
import { withMountNode } from '../../utils/modals';
export default withMountNode(Modal);
